import { Button, colors, Container, Stack, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const Page403 = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <Stack direction='column' justifyContent='center' alignItems='center' sx={{ padding: 4 }} spacing={2}>
        <Typography variant='h6' sx={{ textAlign: 'center', color: colors.grey[700] }}>
          You don't have access to this resource.
        </Typography>
        <Button variant='contained' onClick={() => navigate('/portal')} sx={{ width: 200 }}>
          Back to portal
        </Button>
      </Stack>
    </Container>
  );
};

export default Page403;
